export default __webpack_public_path__ + "static/media/onix.097e66b0.png";